import axios from "../plugins/axios.plugin";

class ServiceAreaService {
  baseServicePath = "/api/service-area";
  filterServiceAreas(payload, page) {
    return axios.post(
      `${this.baseServicePath}/filter/index?page=${page}`,
      payload
    );
  }
  storeServiceAreas(payload) {
    return axios.post(`${this.baseServicePath}/store`, payload);
  }
  searchServiceArea(payload) {
    return axios.post(`${this.baseServicePath}/search/index`, payload);
  }
  editServiceArea(payload) {
    return axios.post(`${this.baseServicePath}/update`, payload);
  }
  deleteServiceArea(payload) {
    return axios.post(`${this.baseServicePath}/delete`, payload);
  }
}
export const serviceAreaService = new ServiceAreaService();
